import { useState, useEffect, useMemo } from "react";
import axios from "axios";
import Helpers from "../Config/Helpers";

function useLocationOptions(navigate) {
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    let active = true;
    axios.get(`${Helpers.baseUrl}/locations/all/${Helpers.authParentId}`, Helpers.headers)
      .then(({ data }) => {
        if (active) setLocations(Array.isArray(data) ? data : []);
      })
      .catch((error) => {
        if (active) {
          Helpers.unauthenticated(error, navigate);
          Helpers.error_response(error);
        }
      });
    return () => { active = false; };
  }, [navigate]);

  return useMemo(() => [
    { label: "No Location", value: "" },
    ...[...locations]
      .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: "base", numeric: true }))
      .map((location) => ({ label: location.name, value: location._id })),
  ], [locations]);
}

export default useLocationOptions;
